import { useCallback } from 'react';
import { toast } from 'sonner';
import { StoreCore } from '../types/store';
import { ExceptionType, ExcuseKey } from '../types/shared';
import { copy } from '../data/copy';
import { uid } from '../utils/db';

export interface ExceptionInput {
  memberId: string;
  type: ExceptionType;
  from: string;
  to: string;
  note: string;
  excuses: ExcuseKey[];
}

export function useExceptionActions(core: StoreCore) {
  const { setDb, family, viewer, isAdmin } = core;

  /** Otrok predlaga; skrbnik izjemo doda neposredno (že odobreno). */
  const submitException = useCallback(
    (input: ExceptionInput) => {
      if (!isAdmin && input.memberId !== viewer.id) return;
      setDb((prev) => ({
        ...prev,
        exceptions: [
          {
            id: uid('ex'),
            familyId: family.id,
            ...input,
            status: isAdmin ? 'odobreno' : 'caka',
            createdBy: viewer.id,
            decidedBy: isAdmin ? viewer.id : undefined,
          },
          ...prev.exceptions,
        ],
      }));
      if (isAdmin) toast.success(input.type === 'bolezen' ? copy.getWell : 'Izjema dodana. Izvedbe so oproščene.');
      else toast.success('Predlog izjeme poslan staršema.');
    },
    [isAdmin, viewer.id, setDb, family.id]
  );

  const decideException = useCallback(
    (id: string, approve: boolean) => {
      if (!isAdmin) return;
      setDb((prev) => ({
        ...prev,
        exceptions: prev.exceptions.map((e) =>
          e.id === id && e.status === 'caka' ? { ...e, status: approve ? 'odobreno' : 'zavrnjeno', decidedBy: viewer.id } : e
        ),
      }));
      toast(approve ? 'Izjema odobrena – izvedbe so oproščene, ne zamujene.' : 'Izjema zavrnjena.');
    },
    [isAdmin, setDb, viewer.id]
  );

  const setSchoolPE = useCallback(
    (value: boolean) => setDb((prev) => ({ ...prev, schoolPE: { ...prev.schoolPE, [`${family.id}:${viewer.id}`]: value } })),
    [setDb, family.id, viewer.id]
  );

  return { submitException, decideException, setSchoolPE };
}
